import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about">
      <div className="about__container">
        <h1>Om Isaks Bilar</h1>
        <div className="about__content">
          <p>
            Välkommen till Isaks Bilar - din pålitliga partner för bilhandel och bilservice. 
            Vi har varit i branschen i många år och hjälper kunder att hitta rätt bil för deras behov.
          </p>
          
          <h2>Vår Mission</h2>
          <p>
            Vi strävar efter att erbjuda transparent, pålitlig och professionell bilhandel 
            med fokus på kundnöjdhet och kvalitet.
          </p>
          
          <h2>Vad vi erbjuder</h2>
          <ul>
            <li>Professionell bilhandel</li>
            <li>Kvalitetskontrollerade bilar</li>
            <li>Finansieringsmöjligheter</li>
            <li>Eftermarknadsservice</li>
            <li>Personlig rådgivning</li>
          </ul>
          
          <h2>Varför välja oss?</h2>
          <p>
            Med många års erfarenhet och ett stort nätverk av partners kan vi erbjuda 
            dig de bästa möjligheterna på bilmarknaden. Vi arbetar endast med pålitliga 
            återförsäljare och garanterar kvalitet i allt vi gör.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;